import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import { IEventCoverArtProps } from "./EventCoverArt";

export const useStyles = makeStyles<Theme, IEventCoverArtProps>((theme) => ({
  root: {
    overflow: "hidden",
    height: "100%",
    width: "100%",
    maxWidth: "780px",
    maxHeight: "490px",
    backgroundColor: theme.palette.white,
    [theme.breakpoints.down("md")]: {
      borderRadius: 0,
    },
  },
  image: {
    width: "100%",
    height: "100%",
    aspectRatio: "780/490",
    backgroundPosition: "center",
    objectFit: "cover",
    display: "block",
    userSelect: "none",
  },
}));
